import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

export default function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);
  const hasShownToast = useRef(false);

  const isAdmin = isAuthenticated && user?.roles?.includes('Admin');

  useEffect(() => {
    if (!isAdmin && !hasShownToast.current) {
      toast.error('Page not found');
      hasShownToast.current = true;
    }
  }, [isAdmin]);

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
